// CircleLoading.js
import React from "react";
import { CircularProgress } from "@mui/material";

export function CircleLoading({size, style}) {
    const progStyle = style ? style : {marginRight:5, marginLeft:5};
    return (
        <React.Fragment>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                    </linearGradient>
                </defs>
            </svg>
            <CircularProgress
                size={size || 20} sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}
                style={progStyle}
            />
        </React.Fragment>
    );
}